@let type = this.type();
@let mainActive = this.mainActive();
@let billActive = this.billActive();

@if (type === 'assistance') {
  <div class="icon" [class.active]="mainActive">
    <svg width="52" height="52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="21.7" stroke="currentColor" stroke-width="2"/>
      <circle cx="16.4" cy="12.7" r="2.1" fill="currentColor"/>
      <circle cx="15" cy="20.8" r="2.1" fill="currentColor"/>
      <circle cx="23.3" cy="17.8" r="2.1" fill="currentColor"/>
      <circle cx="37.8" cy="14.2" r="9.8" fill="var(--svg-fill-color)" stroke="currentColor" stroke-width="2"/>
      <path d="M36 11.3a1.8 1.8 0 1 1 2.8 1.5c-.5.3-1 .7-1 1.2v1.3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      <circle cx="37.8" cy="19" r="1" fill="currentColor"/>
    </svg>
  </div>
} @else if (type === 'bill') {
  <div class="icon" [class.active]="billActive">
    <svg [class.active]="billActive" width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.7 5.3H19.3c-3 0-4.6 0-5.9.5a8.1 8.1 0 0 0-5 5.1C8 12.2 8 14 8 17v37.4c0 2.3 2.6 3.5 4.3 2 1-.9 2.4-.9 3.4 0l1.3 1.2a4.4 4.4 0 0 0 6 0 4.4 4.4 0 0 1 6 0 4.4 4.4 0 0 0 6 0 4.4 4.4 0 0 1 6 0 4.4 4.4 0 0 0 6 0l1.3-1.2c1-.9 2.4-.9 3.4 0 1.7 1.5 4.3.3 4.3-2V17c0-3.2 0-4.8-.4-6a8.1 8.1 0 0 0-5-5.2c-1.3-.5-2.8-.5-6-.5Z"
        stroke="currentColor" stroke-width="2"/>
      <path d="M28 29.3h17.3M18.7 29.3H20M18.7 20H20M18.7 38.7H20M28 20h17.3M28 38.7h17.3" stroke="currentColor"
            stroke-width="2" stroke-linecap="round"/>
    </svg>
  </div>
}

